import axios from 'axios'

 
export default {

    async authReset(params,callback){
        return await axios.post("/app/client/auth/resetpassword",params)
        .then(res=>{
            callback(res)
        })
        .catch(err=>{
            console.log('response error '+err)
        })
    },


    async ifAuthorized(params,callback){
        return await axios.post("/app/client/auth/checkAuth",params)
        .then(res=>{
            callback(res)
        })
        .catch(err=>{
            console.log('response error '+err)
        })
    },



}
 
